<template>
  <div class="sdw_overall">
    <!-- <div class="sdw-runninghorse-wrap">
      <div class="hbb_title sdw-runninghorse-cont" style="background: #fff4f4">
        <span class="sdw-runninghorse-txt" style="font-size: 18px; font-weight:bold;">
          <i class="el-icon-warning" style="font-size: 20px;"></i>
          <span style="margin-left: 5px;">“配件查询”将于 2025 年 8 月 31 日停止服务，建议前往 “智配Store电脑版”使用新版服务</span>
          <el-button type="blue" plain style="margin-left: 20px;" @click="on_gotozsml_click">立即体验</el-button>
        </span>
      </div>
    </div> -->
    <div class="hbb_VinBox">
      <div class="hbb_searchVinBox">
        <div class="hbb_searchVin">VIN码</div>
        <div class="hbb_searchVinCon">
          <div class="hbb_parseImgBox" v-if="vinImgSrc">
            <img :src="vinImgSrc" alt />
          </div>
          <el-input v-model.trim="searchVinKey" @input="checkVinInput" @keyup.enter.native="queryVin()"
            placeholder="请输入您要查询的VIN码"></el-input>
          <div class="hbb_parseText" @click="parseText">粘贴图片</div>
        </div>
        <el-button type="primary" :disabled="canSubmitVin" @click="queryVin">查 询</el-button>
        <div class="hbb_searchVinRecord">
          <el-popover popper-class="hbb_saoma" placement="bottom-end" width="350" trigger="click"
            v-model="RecordVisible">
            <div class="hbb_saomatop">
              扫码记录
              <span class="refresh" @click.stop="onRefresh(0)">
                <img src="@assets/images/shua.png" alt /> 刷新
              </span>
              <span class="rota"></span>
            </div>
            <div class="hbb_saomaList">
              <div class="group" v-for="item in logsList" :key="item" @click="oneLogs(item)">
                <!-- <div class="imgBox">
                <img :src="item.brandLogo" alt />
              </div>-->
                <div class="time">{{ item.lastUpdateTime }}</div>
                <div class="textBox">
                  <span>
                    车&nbsp;&nbsp;型：
                    <b>{{ item.autoText }}</b>
                  </span>
                  <span>
                    VIN码：
                    <b>{{ item.vinCode }}</b>
                  </span>
                  <div>
                    <img src="@assets/images/jian.png" alt />
                  </div>
                </div>
              </div>
            </div>
            <el-button slot="reference" class="hbb_buttonNone" style="padding-right: 0"
              @click="getVinList(1)">扫码记录</el-button>
            <!-- 定制的成功提示 -->
            <div class="el-message el-message--success sdw_saoma_toast" style="top: 20px; z-index: 2019"
              v-if="saoma_toast_launched">
              <i class="el-message__icon el-icon-success"></i>
              <p class="el-message__content">刷新成功</p>
            </div>
          </el-popover>
        </div>
      </div>
      <div class="hbb_searchOther">
        <div>
          <span>当前车型：</span>
          <span>{{ auto_text }}</span>
        </div>
        <div>
          <el-button class="hbb_jishu" @click="technologyClick">车型详情</el-button>
        </div>
      </div>
    </div>
    <!-- <el-dialog
      v-if="query_mode != 'inshop' && isShowExpireHint"
      :visible="isShowHintDialog"
      custom-class="sdw-notvipdialog"
      :show-close="false"
      center
      width="840px"
      style="margin-top: 15vh"
    >
      <div class="hah-main-popup">
        <div class="hah-content" style="text-align: center">
          因系统升级，本页面将在
          <span class="hah-red"
            ><span class="hah-redbg">{{ times.day }}</span> 天</span
          >
          后停止运行
          <p class="hah-del hah-red">请升级或对接至智配Store查询与进销存系统</p>
          <el-button @click="times.secondtime == 0 ? on_Close() : ''"
            >知道了<span v-if="times.secondtime > 0"
              >({{ times.secondtime }}s)</span
            ></el-button
          >
          <el-button type="primary" @click="gotoSaasIntroduce()"
            >了解智配Store进销存</el-button
          >
        </div>
        <div class="hah-imgbox">
          <img src="../../../assets/images/wxQRcode.png" alt="" />
          <div class="hah-imgbox-font">
            <img src="../../../assets/images/wxicon.png" alt="" />
            <div>扫码联系客服</div>
          </div>
        </div>
      </div>
    </el-dialog> -->
    <!-- 非VIP提示弹层 -->
    <el-dialog title="" v-if="isShowNotVipDialog" :visible="isShowNotVipDialog" custom-class="sdw-notvipdialog"
      :show-close="false" center width="480px">
      <div slot="title" style="text-align: center">
        <span class="el-icon-warning" style="color: #fecd09; font-size: 55px"></span>
      </div>
      <div style="text-align: center">
        <p style="font-size: 16px; line-height: 30px">
          该功能需开通智配Store VIP会员才能使用
        </p>
        <p style="font-size: 12px; color: #e74c3c; line-height: 20px">
          请登录智配Store APP后, 点击"我的-智配VIP"后的"立即开通"按钮
        </p>
      </div>

      <div slot="footer">
        <el-button type="primary" @click="isConfirmNotVip = true">确 认</el-button>
      </div>
    </el-dialog>

    <!-- VIP购买弹层 -->
    <!-- <el-dialog
      title="配件查询为智配Store VIP会员服务内容，请先购买智配Store VIP"
      :visible.sync="isPaymentShow"
      v-if="isPaymentShow"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="630px"
      @close="PayhandleClose()"
      :modal-append-to-body="false"
      append-to-body
    >
      <payment ref="payment" @PaySuccess="On_PaySuccess()"></payment>
    </el-dialog> -->

    <!-- VIP购买成功弹层 -->
    <!-- <el-dialog
      title="VIP会员"
      width="750px"
      :visible.sync="isPaySuccessShow"
      v-if="isPaySuccessShow"
      :before-close="handleClose"
      :modal-append-to-body="false"
      append-to-body
    >
      <div class="wrapper_box">
        <div class="wrapper-view">
          <img
            class="wrapp-img"
            src="@assets/images/icon_success1.png"
            alt=""
          />
          <p class="wrapp-main">购买智配Store VIP成功</p>
          <p class="wrapp-min">您可以在会员期内不限次数查询</p>
        </div>
      </div>
    </el-dialog> -->
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import server from "@/utils/server";
import payment from "@components/payment/payment";
export default {
  components: {
    // AutoCarDetail
    payment,
  },
  props: {
    isParseClick: {
      type: Boolean,
      default: false,
    },
    // VvipCount: Number,
    IsVip: Boolean,
    userInfo: Object, //当前用户,
  },
  data() {
    return {
      hostDomian: process.env.VUE_APP_API_DOMAIN, // 不同环境走不同的地址
      query_mode: this.$route.query.mode || "standalone", // 启动模式 inshop: 代表门店启动的嵌入模式
      vincodeQuery: this.$route.query.v, // 查询vin码 用于管控页面的前进后退
      // isShowExpireHint: true, //是否展示到期服务
      RecordVisible: false, // 扫码记录弹层
      searchVinKey: "", // 搜索Vin码的key值
      canSubmitVin: true, // 是否可以点击查询VIN码按钮
      // autoCarVisible: false, // 查看车型详情 是否启动
      logsList: [], // vin码记录
      vinImgSrc: "", // 识别出来的vin码的图片
      auto_text: "", //车型文案
      autoInfo: {}, // 获取车型的简易信息
      jYAutoByVin: {}, // 获取车型的详细信息
      saoma_toast_launched: false, //扫码成功提示是否启动
      isConfirmNotVip: false, //是否已知晓非VIP
      // isPaySuccessShow: false, // 是否支付成功
      totalTime: 3,
      // isShowHintDialog: false, //服务停止提醒弹层
      curStartTime: "2021-10-15 23:59:59", //截止时间
      times: {
        timeCookie: "",
        day: "",
        hour: "",
        min: "",
        second: "",
        secondtime: 3,
      }, //时间倒计时
    };
  },
  computed: {
    ...mapGetters({
      carNumber: "CommonModule/getcarNumber",
      isCreated: "CommonModule/getViewModalOver",
      isReturnRequest: "CommonModule/getReturnRequest",
    }),
    isShowNotVipDialog() {
      if (this.isConfirmNotVip) return false;
      // if (this.isPaySuccessShow) return false;
      return !this.IsVip;
    },
  },
  created() {
    // 非店铺打开则前往saas介绍页
    if (this.query_mode != "inshop") {
      location.href = "https://www.zhipeicloud.com";
    }
    // if (
    //   this.getCookie(
    //     "expire_hint_" + this.timeStamp2String(new Date()).substring(0, 10)
    //   )
    // ) {
    //   // 当天已读
    //   this.isShowHintDialog = false;
    // } else {
    //   // 当天未读
    //   this.countTime();
    //   this.isShowHintDialog = true;
    //   let times = setInterval(() => {
    //     if (this.times.secondtime == 0) {
    //       clearInterval(times);
    //       return;
    //     }
    //     this.times.secondtime--;
    //   }, 1000);
    // }
  },
  watch: {
    userInfo: {
      handler: function (val) {
        //手机尾号为1的展示到期提示
        // if (this.userInfo.mobile) {
        //   var last_char = this.userInfo.mobile.substring(
        //     this.userInfo.mobile.length - 1
        //   );
        //   this.isShowExpireHint = last_char == "1";
        // }
      },
    },
  },
  mounted() {
    if (this.vincodeQuery) {
      this.searchVinKey = this.vincodeQuery;
      this.setRequestData({
        resSrc: this.vincodeQuery,
        type: 1,
      });
    } else {
      return false;
    }
  },
  methods: {
    ...mapMutations({
      setViewModalOver: "CommonModule/SET_VIEWMODALOVER",
      setRequestData: "CommonModule/SET_REQUESTDATA",
    }),
    ...mapActions({
      GetVinSearchLogs: "SearchResultModule/GetVinSearchLogs",
    }),
    on_Close() {
      // 当天已读 伪代码10分钟有效期
      // this.setCookie("isShowHintDialog", true, 10 / 24 / 60);
      // this.setCookie(
      //   "expire_hint_" + this.timeStamp2String(new Date()).substring(0, 10),
      //   true,
      //   1
      // );
      // this.isShowHintDialog = false;
    },
    // 倒计时
    countTime() {
      // 获取当前时间
      let date = new Date();
      let now = date.getTime();
      // 设置截止时间
      let endDate = new Date(this.curStartTime); // this.curStartTime需要倒计时的日期
      let end = endDate.getTime();
      // 时间差
      let leftTime = end - now;
      // 定义变量 d,h,m,s保存倒计时的时间
      if (leftTime >= 0) {
        // 天
        this.times.day = Math.floor(leftTime / 1000 / 60 / 60 / 24);
        // 时
        let h = Math.floor((leftTime / 1000 / 60 / 60) % 24);
        if (h > 0) this.times.day++;
        this.times.hour = h < 10 ? "0" + h : h;
        // 分
        let m = Math.floor((leftTime / 1000 / 60) % 60);
        this.times.min = m < 10 ? "0" + m : m;
        // 秒
        let s = Math.floor((leftTime / 1000) % 60);
        this.times.second = s < 10 ? "0" + s : s;
      } else {
        this.times.day = 0;
        this.times.hour = "00";
        this.times.min = "00";
        this.times.second = "00";
      }
      // 等于0的时候不调用
      if (
        Number(this.hour) === 0 &&
        Number(this.day) === 0 &&
        Number(this.min) === 0 &&
        Number(this.second) === 0
      ) {
        return;
      } else {
        // 递归每秒调用countTime方法，显示动态时间效果,
        // setTimeout(this.countTime, 1000)
      }
    },

    checkVinInput(key) {
      // 搜索VIN码input改变事件
      let _this = this;
      if (_this.searchVinKey == "") {
        _this.canSubmitVin = true;
        return false;
      }
      _this.canSubmitVin = false;
    },
    onRefresh(type) {
      // 刷新新的vin码
      this.getVinList(type);
    },
    gotoSaasIntroduce() {
      window.open("https://saas.zhipeicloud.com/Home/SaasIntroduce", "_blank");
    },
    queryVin() {
      if (!this.IsVip) {
        this.isConfirmNotVip = false;
        // //记录行为日志-引导支付 被动
        // this.WriteVvipBehaviorLog_guidepay("passive");
      } else {
        // 查询vin
        // 每次点击重置vuex数据是否渲染完的状态值
        if (this.carNumber == 1) {
          this.setViewModalOver(true);
        }
        if (!this.isCreated) {
          this.$message({
            type: "info",
            message: "当前列表数据未加载完，请稍后重试",
          });
          return false;
        }
        this.setViewModalOver(false);

        this.$emit("queryVinEvent", this.searchVinKey);
      }
    },
    parseText() {
      this.$emit("parseTextEvent");
    },
    PayhandleClose() {
      this.$refs.payment.clearPayQuey();
    },
    //关闭
    // On_PaySuccess() {
    //   this.isConfirmNotVip = false;
    //   this.isPaySuccessShow = true;
    //   window.setInterval(() => {
    //     this.totalTime--;
    //     if (this.totalTime == 0) {
    //       this.toDepositManageList();
    //     }
    //   }, 1000);
    // },
    //跳转到列表页
    toDepositManageList() {
      let href = this.hostDomian + "#/SearchResult";
      top.location.href = href;
    },
    getVinList(type) {
      var loading = Vue.prototype.$loading({
        lock: true,
        spinner: "el-icon-loading",
        target: document.querySelector(".hbb_saoma"), //设置加载动画区域
      });
      this.GetVinSearchLogs().then((res) => {
        loading.close();
        this.logsList = res.logs;
        if (!type) {
          this.saoma_toast_launched = true;
          setTimeout(() => {
            this.saoma_toast_launched = false;
          }, 2000);
          $(".hbb_saomaList").animate({ scrollTop: 0 }, 200);
        }
      });
    },

    // lookCarDetail() {
    //   // 点击查看车型详情
    //   let _this = this;
    //   this.autoCarVisible = true;
    //   setTimeout(() => {
    //     _this.$refs.autoCarDetail.active(_this.jYAutoByVin, _this.searchVinKey);
    //   }, 0);
    // },
    oneLogs(item) {
      // 点击历史vin码记录进行筛选

      this.RecordVisible = false;
      this.$emit("logsItemClick", item, 1);
    },
    technologyClick() {
      let _this = this;
      _this.$emit("technologyEvent");
    },
    goBuyVip() {
      this.isConfirmNotVip = true;
      //记录行为日志-引导支付 主动
      this.WriteVvipBehaviorLog_guidepay("active");
    },
    //记录行为日志-引导支付
    WriteVvipBehaviorLog_guidepay(Property) {
      server
        .myAxios("/api/BehaviorLog/WriteVvipBehaviorLog", {
          BehaviorType: "ydzf",
          BehaviorProperty: Property,
        })
        .then((res) => {
          //do nothing
        });
    },

    //前往专属目录
    on_gotozsml_click() {
      // window.location.href = `${process.env.VUE_APP_SAAS_DOMAIN}/IFrameWrapper/Index?pageid=zsml`;
      window.open(`${process.env.VUE_APP_SAAS_DOMAIN}/IFrameWrapper/Index?pageid=zsml`, "_blank");
    }
  },
};
</script>

<style>
.hah-main-popup {
  display: flex;
  /* align-items: center; */
  justify-content: center;
  padding: 50px 40px 40px;
}

.hah-content {
  flex: 1;
  padding-top: 28px;
  font-size: 24px;
  font-weight: 700;
  color: #181818;
  margin-right: 48px;
}

.hah-red {
  color: #e74c3c;
}

.hah-redbg {
  font-size: 36px;
  font-weight: 700;
}

.hah-del {
  padding-top: 12px;
  font-size: 16px;
  font-weight: 400;
  line-height: 28px;
  margin-bottom: 40px;
}

.hah-imgbox {
  width: 184px;
}

.hah-imgbox img {
  width: 184px;
  height: 184px;
}

.hah-imgbox-font {
  font-size: 16px;
  font-family: PingFangSC, PingFangSC-Semibold;
  font-weight: 600;
  text-align: left;
  color: #ff1b0e;
  line-height: 24px;
  letter-spacing: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hah-imgbox-font img {
  width: 20px;
  height: 20px;
  margin-right: 8px;
}

.hbb_VinBox {
  border: 1px solid #d8d8d8;
  margin-top: 10px;
  padding: 0 20px;
  background: #fff;
}

.hbb_title {
  /* margin-left: -20px; */
  /* margin-bottom: 16px; */
  margin-top: 10px;
  height: 40px;
  font-size: 14px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  line-height: 40px;
  /* text-align: center; */
  color: #e74c3c;
  /* width: calc(100% + 40px ); */
  width: 200%;
  border: 1px solid #e74c3c;
  /* position: absolute; */
  /* top: 70px; */
  /* z-index: 1; */
}

.hbb_title .blue {
  cursor: pointer;
  color: #4585e9;
  /* margin-left: 10px; */
}

.hbb_searchVinBox {
  display: flex;
  width: 100%;
  align-items: center;
  background: #fff;
  padding: 10px 0;
}

.hbb_searchVin {
  width: 70px;
  font-size: 14px;
  text-align: left;
  color: #767676;
}

.hbb_searchVinCon {
  display: flex;
  width: 80%;
  align-items: center;
  border: 2px solid #999;
  /* padding: 0 30px 0 10px; */
  margin-right: 30px;
}

.hbb_searchVinCon .el-input .el-input__inner {
  border: none;
  width: 100%;
  line-height: 30px;
  height: 30px;
}

.hbb_searchVinRecord {
  padding: 0 20px;
  /* width: 140px; */
  padding-right: 0;
}

.hbb_searchVinRecord span {
  font-size: 14px;
  color: #4585e9;
  cursor: pointer;
}

.hbb_searchOther {
  display: flex;
  width: 100%;
  padding: 10px 0;
  color: #767676;
  font-size: 12px;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #ddd;
  background: #fff;
}

.hbb_searchOther span.lookDetail {
  color: #4585e9;
  margin-left: 20px;
  cursor: pointer;
}

.hbb_parseText {
  width: 70px;
  color: #4585e9;
  margin: 0 10px;
  font-size: 13px;
  cursor: pointer;
}

.hbb_parseImgBox {
  width: 20px;
  height: 17px;
  background: #fff;
  overflow: hidden;
  margin-left: 8px;
}

.hbb_parseImgBox img {
  width: 100%;
  height: 100%;
}

.hbb_buttonNone {
  border: none;
  /*双击文字、input等，出现的蓝色底色，如何去除*/
  -moz-user-select: none;
  /*火狐*/
  -webkit-user-select: none;
  /*webkit浏览器*/
  -ms-user-select: none;
  /*IE10*/
  background: none !important;
  /*-khtml-user-select:none;!*早期浏览器*!*/
}

.hbb_buttonNone:hover {
  border: none !important;
  background: none !important;
  color: #377de8;
}

.hbb_saomaList {
  /* display: flex; */
  width: 100%;
  max-height: 400px;
  overflow: hidden;
  overflow-y: auto;
  flex-direction: column;
  cursor: pointer;
  background-color: #ecf2f6;
  padding-top: 10px;
}

.hbb_saomaList .group {
  display: flex;
  width: 100%;
  margin-bottom: 10px;
  flex-direction: column;
}

/* .hbb_saomaList .group:hover{
      background: #ffeeec;
  } */
.hbb_saomaList .group:hover .textBox {
  color: #ff695c;
}

.hbb_saomaList .group .imgBox {
  width: 44px;
  height: 44px;
  border: 1px solid #ddd;
  border-radius: 5px;
}

.hbb_saomaList .group .imgBox img {
  width: 100%;
  height: 100%;
}

.hbb_saomaList .group .time {
  float: left;
  width: 100%;
  text-align: center;
  font-size: 12px;
  color: #d1d9e2;
  margin-bottom: 5px;
}

.hbb_saomaList .group .textBox {
  display: flex;
  width: 100%;
  flex-direction: column;
  font-size: 12px;
  background-color: #fff;
  border-top: 1px solid #ddd;
  padding: 5px 10px;
  border-bottom: 1px solid #ddd;
  position: relative;
}

.hbb_saomaList .group .textBox span {
  margin-top: 5px;
  color: #b1b1b1;
  font-size: 12px;
}

.hbb_saomaList .group .textBox b {
  color: #666;
}

.hbb_saomaList .group .textBox div {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 10px;
  margin: auto;
  height: 15px;
  font-size: 14px;
}

.hbb_saomaList .group .textBox:hover * {
  color: #e74c3c;
}

.hbb_saomatop {
  display: flex;
  width: 100%;
  background: #d53532;
  height: 30px;
  align-items: center;
  color: #fff;
  font-size: 14px;
  justify-content: center;
  z-index: 111;
  border-radius: 5px 5px 0 0;
  /* margin-bottom: 15px; */

  position: relative;
}

.hbb_saomatop .rota {
  width: 10px;
  height: 10px;
  background: #d53532;
  position: absolute;
  transform: rotate(-45deg);
  top: -5px;
  right: 20px;
}

.hbb_saomatop .refresh {
  position: absolute;
  z-index: 9;
  color: #fff;
  right: 10px;
  font-size: 12px;
  top: 8px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.hbb_saomatop .refresh img {
  margin-right: 4px;
}

.hbb_saoma {
  box-shadow: 0 0 6px rgba(231, 76, 60, 0.52);
  border-radius: 5px;
  padding: 0;
  border: 0;
}

.hbb_jishu {
  padding: 0 20px;
  border: 1px solid #e74c3c;
  color: #e74c3c;
  margin-right: 30px;
}

.hbb_jishu:hover {
  color: #fff !important;
}

.hbb_saoma .popper__arrow {
  display: none;
}

.sdw_saoma_toast {
  position: absolute;
  min-width: 100px;
}

.wrapper_box {
  height: 423px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.wrapper-view {
  width: 251px;
  height: 256px;
  /* display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center; */
  text-align: center;
}

.wrapp-img {
  width: 68px;
  height: 68px;
}

.wrapp-main {
  font-size: 24px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  text-align: center;
  color: #181818;
  line-height: 42px;
}

.wrapp-min {
  font-size: 16px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: center;
  color: #e74c3c;
  line-height: 34px;
}

.sdw-notvipdialog {
  min-width: 100px !important;
  padding: 26px 0;
}

.sdw-notvipdialog .el-dialog__header {
  border-bottom: 0;
}

.sdw-notvipdialog .el-dialog__footer {
  border-top: 0;
  padding: 10px 20px;
}

.sdw-notvipdialog .el-dialog__body {
  font-size: 16px;
  color: black;
  padding: 6px 25px;
}

.sdw_overall .sdw-runninghorse-wrap {
  width: 100%;
  /* height: 50px; */
  overflow: hidden;
  white-space: nowrap;
  position: relative;
  margin: 0px auto;
}

.sdw-runninghorse-wrap .sdw-runninghorse-cont {
  width: 100%;
  height: 40px;
  overflow: hidden;
  white-space: nowrap;
  position: relative;
  /* margin: 10px auto; */
}

.sdw-runninghorse-cont:hover .sdw-runninghorse-txt {
  /* animation-play-state: paused; */
}

.sdw-runninghorse-wrap .sdw-runninghorse-txt {
  display: inline-block;
  position: absolute;
  top: 0;
  left: 10%;
  height: 100%;
  width: 200%;
  /* animation: 20s move infinite linear; */
  /* -webkit-animation: 20s move infinite linear; */
  /* text-align: right; */
}

.sdw-runninghorse-wrap:hover .sdw-runninghorse-cont {
  /* -webkit-animation-play-state: paused; */
}

@-webkit-keyframes move {
  0% {
    left: 0;
  }

  100% {
    left: -200%;
  }
}
</style>